/**
 * atleta-sticky.js
 * Sticky CTA bar behaviour — show after testimonials section scrolls out of view.
 * GTM dataLayer events for all CTAs, sport cards, and FAQ toggles.
 */
(function () {
  'use strict';

  var sticky   = document.getElementById('atleta-sticky');
  var testim   = document.querySelector('.atleta-lp .atleta-section--social-proof');
  var hero     = document.querySelector('.atleta-lp .atleta-section--hero');

  if (!sticky) return;

  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    var trigger;
    if (testim) {
      trigger = testim.offsetTop + testim.offsetHeight - 80;
    } else if (hero) {
      trigger = hero.offsetTop + hero.offsetHeight + 100;
    } else {
      trigger = 400;
    }

    if (y > trigger) {
      sticky.classList.add('visible');
      document.body.classList.add('atleta-sticky-active');
    } else {
      sticky.classList.remove('visible');
      document.body.classList.remove('atleta-sticky-active');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // GTM dataLayer events
  window.dataLayer = window.dataLayer || [];

  document.querySelectorAll('.atleta-lp [data-event]').forEach(function (el) {
    el.addEventListener('click', function () {
      var ev    = el.getAttribute('data-event');
      var extra = el.getAttribute('data-q') || el.getAttribute('data-sport') || '';
      var page  = document.body.getAttribute('data-atleta-page') || 'unknown';
      window.dataLayer.push({ event: 'atleta_' + ev, label: extra, page: page });
    });
  });

  // FAQ accordion toggle events
  document.querySelectorAll('.atleta-lp details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        window.dataLayer.push({
          event: 'atleta_faq_open',
          label: d.getAttribute('data-q') || '',
          page:  document.body.getAttribute('data-atleta-page') || 'unknown'
        });
      }
    });
  });
})();
